import { useMagicKeys } from "@vueuse/core";
import { computed } from "vue";

const keys = useMagicKeys();

export const altPressed = computed(() => {
  return keys.current.has("alt");
});
